import { EventEmitter, Input, Output } from '@angular/core';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RowNode, SelectionChangedEvent } from 'ag-grid-community';
import { DynamictagsInlineComponent } from '../../../../../bodisplay/dynamictags-inline/dynamictags-inline.component';
import { CustomGridService } from '../../../../../customgrid';
import { ComboProperty, QResult, QueovalBase, Select } from '../../../../../models';
import { GenericEffectif } from '../../../../../models/effectif/genericEffectif.model';
import { ModeEffectif, Option, RenderType } from '../../../../../models/effectif/option.model';
import { ContractData, StageDocumentContract, StageDocumentUpdate } from '../../../../../models/formation';
import { CoreService, HttpService } from '../../../../../services';
import { ToastService } from '../../../../../toast';
import { StageService } from '../../services/stage-modal.service';
import { DocumentService } from '../document.service';

@Component({
  selector: 'queoval-stage-generation-contrat-formateur',
  templateUrl: './generation-contrat-formateur.component.html',
  styleUrls: ['./generation-contrat-formateur.component.css']
})
export class GenerationContratFormateurComponent implements OnInit {

  @Input('refreshGrid') set SetRefreshGrid(value: boolean) {
    if (value) {
      this.refreshData = value;
      setTimeout(() => { this.refreshGridChange.emit(false); }, 250);
    }

  }
  @Output() refreshGridChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild('dynamictagsInline') dynamictagsInline: DynamictagsInlineComponent;

  public emptyModel = false;

  //public NivseCNTOptions: Array<Select> = [];
  //public SelectedNiveauCNTExtranet: Select = new Select('', '- - - - - -');

  public ModelsList: Array<Select> = [];
  public SelectedModel: Select = new Select('', '- - - - - -');

  public OptionFormateur: Option;

  /*#region value in "Contrat"*/
  public CoutFormateur: number = 0;
  public NbHeureStage: number = 0;
  public NbJour: number = 0;
  public TauxTVA: number = 0;
  public ModeCalculJour: boolean = true;
  public MontantHT: number = 0;
  public MontantTVA: number = 0;
  public MontantTTC: number = 0;

  /*#endregion */

  /**
   * Ident du formateur sélectionné
   */
  public IdFormateurSelected: string;

  public DocIsGenereted: boolean;

  public refreshData: boolean;

  public selectedNodes: RowNode[];

  /**
   * Boolean pour savoir si la génération est en cours
   */
  public IsGenerate: boolean;

  /** Liste de string qui sert a stocker les idents des reservations,
   * (Output du composant ListReservationComponent)
   * */
  public LstIdentReservation: string[];

  constructor(
    public service: StageService,
    private http: HttpService,
    private indParam: CoreService,
    private toast: ToastService,
    private modalService: NgbModal,
    public docService: DocumentService,
    private customGridService: CustomGridService
  ) { }

  ngOnInit(): void {
    this.DocIsGenereted = false;
    this.IsGenerate = false;
    this.LstIdentReservation = [];

    // Récupération des modèles de document
    this.http.getHttp<QResult<ComboProperty>>(`${this.indParam.AppParams.apiUrl}api/Stage/Document/MODELES_CONTRAT_FORMATEUR/0`).subscribe
      ((result: QResult<ComboProperty>) => {
        this.SelectedModel.id = result.Value.DefaultProperty;
        this.ModelsList = result.Value.ListProperty;
      });

    this.OptionFormateur = new Option(this.service.Stage.Ident, this.service.Stage.Ident, ModeEffectif.FORMATEURSINGLE);

  }
  //#endregion Cycle de vie

  public GetFormateur(event: Array<GenericEffectif>): void {
    if (event) {
      if (event.length > 0) {
        this.IdFormateurSelected = event[0].Id;
        this.DocIsGenereted = false;
        this.SetInfoContract();
      }
    }
  }


  /* 
   * Permet de recharger la grid
   */
  public refreshGrid(): void {
    this.refreshGridChange.emit(true);
  }

  /*
   * Permet d'avoir les lignes selectionnées
   */
  public selectLine(event: SelectionChangedEvent) {
    this.selectedNodes = event.api.getSelectedNodes();
  }

  /**
   * recupère la liste d'ident des réservations par rapport
   * à l'Output du composant ListReservationComponent
   * @param event Liste d'ident des reservations
   */
  public GetReservations(event: [string]) {
    this.LstIdentReservation = event;
  }

  /** Ouvrir une modal , la taille dépend du paramètre xl (vrai par default => modal taille q-xxl)
 * 
 * @param Modal la modal qui doit être ouverte
 * @param xl si oui la modal est grande, sinon elle est de taille réduite
 */
  public open(Modal: any, xl: boolean = true) {
    if (xl) {
      this.modalService.open(Modal, { centered: true, size: 'q-xxl', windowClass: 'qmodalover' });
    } else {
      this.modalService.open(Modal, { centered: true, windowClass: 'qmodalover' });
    }
  }

  /*
  * Supprimer les documents selectionnés
  */
  public DeleteSelection() {
    let documentModel = new StageDocumentUpdate();
    documentModel.DocumentIdentList = new Array<string>();
    this.selectedNodes.forEach((document) => {
      documentModel.DocumentIdentList.push(document.data.Ident)
    });
    documentModel.StringData = this.service.Stage.Ident;
    documentModel.TypeDocument = 'CONTRAT';
    this.http.postHttp<QResult<StageDocumentUpdate>>(`${this.indParam.AppParams.apiUrl}api/Stage/Document/DELETE_CONTRAT`, documentModel).subscribe(
      (result: QResult<StageDocumentUpdate>) => {
        if (!result.HasError) {
          this.toast.showSuccessToast("Document(s) supprimé(s)");
          this.refreshGrid();
          this.selectedNodes = [];
        }
        this.indParam.showSplash(false);
      });
  }

  /**
   * Creation du contrat formateur
   **/
  public CreateContract(): void {
    if (this.IsGenerate) {
      this.toast.showInfoToast('Génération en cours');
      return;
    }
    // Vérification du choix de type de document
    if (!this.SelectedModel || !this.SelectedModel.id || this.SelectedModel.id == '') {
      this.toast.showAlertToast('Veuillez sélectionner un type de document')
      this.emptyModel = true;
    }
    if (!this.dynamictagsInline.HasEmptyProp() && !this.emptyModel) {
      // Création du modèle complet
      const model: StageDocumentContract = new StageDocumentContract();
      model.IdStage = this.service.Stage.Ident;
      model.IdTrainer = this.IdFormateurSelected;
      model.LstIdentReservation = this.LstIdentReservation;
      model.Contract = new ContractData();
      model.Contract.Modele = this.SelectedModel.id;
      model.Contract.Cout = this.CoutFormateur;
      model.Contract.ModeCalculJour = this.ModeCalculJour;
      model.Contract.NbHoursStage = this.NbHeureStage;
      model.Contract.NbJour = this.NbJour;
      model.Contract.TauxTVA = this.TauxTVA;
      this.IsGenerate = true;
      this.http.postHttp<QResult<string>>(`${this.indParam.AppParams.apiUrl}api/Stage/Document/Contrat/CREATE_CONTRAT_FORMATEUR/`, model).subscribe(
        (result: QResult<string>) => {

          if (result.Value && result.Value != "0") {
            this.dynamictagsInline.idDonnee = result.Value;
            this.dynamictagsInline.OnSave().subscribe(() => {
              this.IsGenerate = false;
              this.dynamictagsInline.idDonnee = "0";

              // Mise à jour de la custom grid
              this.toast.showSuccessToast("Contrat formateur créé");
              this.refreshGrid();
              this.selectedNodes = [];
            });
          }
          else {
            this.IsGenerate = false;
            // Mise à jour de la custom grid
            this.toast.showSuccessToast("Contrat formateur créé");
            this.refreshGrid();
            this.selectedNodes = [];
          }
        });
    }
  }

  /*
  * Regénération des documents selectionnés
  */
  public RegenereDoc() {
    let documentModel = new StageDocumentUpdate();
    documentModel.DocumentIdentList = new Array<string>();
    this.selectedNodes.forEach((document) => {
      documentModel.DocumentIdentList.push(document.data.Ident)
    });
    documentModel.StringData = this.service.Stage.Ident;
    documentModel.TypeDocument = "CONTRATFORMATEUR";
    this.http.postHttp<QueovalBase>(`${this.indParam.AppParams.apiUrl}api/Stage/Document/GENERATE_DOC`, documentModel).subscribe(
      (result: QueovalBase) => {
        if (!result.HasError) {
          this.toast.showSuccessToast("Document(s) généré(s)");
          this.refreshGrid();
          this.selectedNodes = [];
        }
        this.indParam.showSplash(false);
      });
  }

  // Calcul des montants

  public CalculMontantHT(): number {
    if (this.ModeCalculJour) {
      this.MontantHT = this.CoutFormateur * this.NbJour;
    }
    else {
      this.MontantHT = this.CoutFormateur * this.NbHeureStage;
    }
    return this.MontantHT;
  }

  public CalculTauxTVA(): number {
    this.MontantTVA = this.MontantHT * (this.TauxTVA / 100);
    return this.MontantTVA;
  }

  public CalculMontantTTC(): number {
    this.MontantTTC = this.MontantHT + this.MontantTVA;
    return this.MontantTTC;
  }

  //#endregion Fonctions Publics



  //#region Fonction Privates

  private SetInfoContract(): void {
    const model: StageDocumentContract = new StageDocumentContract();
    model.IdStage = this.service.Stage.Ident;
    model.IdTrainer = this.IdFormateurSelected;
    this.http.postHttp<QResult<StageDocumentContract>>(`${this.indParam.AppParams.apiUrl}api/Stage/Document/Contrat/SET_CONTRAT_DATA/`, model).subscribe(
      (data: QResult<StageDocumentContract>) => {
        // Mise à jour des données du contrat
        this.CoutFormateur = data.Value.Contract.Cout;
        this.ModeCalculJour = data.Value.Contract.ModeCalculJour;
        this.NbHeureStage = data.Value.Contract.NbHoursStage;
        this.NbJour = data.Value.Contract.NbJour;
        this.TauxTVA = data.Value.Contract.TauxTVA;
      });
  }

  //#endregion Fonction Privates

}
